const getDefaultState = () => {
  return {
    showModalBilling: false,
    typeModal: 'ADD',
    billings: [],
    userBilling: {
      businessName: '',
      businessIdentifier: '',
      email: '',
      addressDepartment: '',
      addressProvince: '',
      addressDistrict: '',
      address: '',
      buycorporate: 0,
    },
    userId: ''
  };
};

// initial state
const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  CHANGE_SHOW_MODAL_BILLING(state, payload) {
    state.showModalBilling = payload;
  },
  CHANGE_TYPE_MODAL_BILLING(state, payload) {
    state.typeModal = payload;
  },
  SET_BILLINGS(state, payload) {
    state.billings = [];
    let array = [];
    payload.map((elem) => {
      elem.selected = false;
      array.push(elem);
    });
    state.billings = array;
  },
  SET_BILLING(state, payload) {
    state.userBilling = payload;
  },
  SET_BILLING_USER_ID(state, payload) {
    state.userId = payload;
  },
  SELECTED_BILLING(state, payload) {
    let billingsSelected = [];
    state.billings.forEach((elem) => {
      if (elem.id !== payload.id) {
        elem.selected = false;
      } else {
        elem.selected = true;
      }
      billingsSelected.push(elem);
    });
    state.billings = billingsSelected;
  },
  RESET_FORM_BILLING(state) {
    state.userBilling.businessName = '';
    state.userBilling.businessIdentifier = '';
    state.userBilling.email = '';
    state.userBilling.addressDepartment = '';
    state.userBilling.addressProvince = '';
    state.userBilling.addressDistrict = '';
    state.userBilling.address = '';
  }
};

const actions = {
  resetStateBilling({ commit }) {
    commit('RESET_STATE');
  },
  resetFormBilling({ commit }) {
    commit('RESET_FORM_BILLING');
  },
  changeShowModalBilling({ commit }, payload) {
    commit('CHANGE_SHOW_MODAL_BILLING', payload);
  },
  changeTypeModalBilling({ commit }, payload) {
    commit('CHANGE_TYPE_MODAL_BILLING', payload);
  },
  setBillings({ commit }, payload) {
    commit('SET_BILLINGS', payload);
  },
  setBilling({ commit }, payload) {
    commit('SET_BILLING', payload);
  },
  setBillingUserId({ commit }, payload) {
    commit('SET_BILLING_USER_ID', payload);
  },
  selectedBillings({ commit }, payload) {
    commit('SELECTED_BILLING', payload);
  }
};

export default {
  state,
  getters: {
    showModal(state) {
      return state.showModalBilling;
    },
    getBillings(state) {
      return state.billings;
    }
  },
  actions,
  mutations
};
